{
  "serviceForms": {
    "joinCorporateForm": {
      "fields": {
        "authorisedSignatory": {
          "label": "Minulla on oikeus allekirjoittaa sopimus yritykseni puolesta",
          "description": "Jos matkustat työksesi ja haluat yrityksesi liittyvän ohjelmaan, voit jakaa tämän sivun henkilölle, jolla on allekirjoitusoikeus yrityksessäsi.",
          "required": "Vahvistus vaaditaan"
        },
        "country": {
          "availability": "Finnair for Business on tarjolla näissä maissa."
        }
      },
      "summary": {
        "confirmationTitle": "Vahvista hakemuksesi",
        "confirmationText": "<p>Katso <a href=\"{link}\" target=\"_blank\" rel=\"noopener noreferrer\">Finnair for Business -jäsenyysehdot</a>. Tiedot henkilörekisteristä, henkilötietojen käyttämisestä ja rekisteröidyn oikeuksista ovat luettavissa <a data-contentid=\"442072\" href=\"/fi-fi/info/finnairin-tietosuojaseloste\" target=\"_blank\" rel=\"noopener noreferrer\">rekisteriselosteessamme</a>.</p>",
        "termsConfirmation": {
          "label": "Olen tutustunut sopimusehtoihin ja yritykseni hyväksyy noudattavansa niitä. Vakuutan antamani tiedot oikeiksi.",
          "required": "Pakollinen kenttä"
        }
      },
      "travelAgency": {
        "title": "Yrityksesi käyttämä matkatoimisto (3/4)",
        "info": "<p>Jos yrityksesi varaa lentoja matkatoimiston kautta, lisää sen tiedot tähän. Tiimisi saa silloin Finnair for Business -alennukset ja -edut käyttöönsä myös varatessaan matkatoimiston kautta.</p><p>Jos et käytä matkatoimistoa tai sinulla ei vielä ole sen tietoja, valitse <b>Seuraava</b>. Voit lähettää tiedot meille myöhemmin.</p>",
        "checkbox": {
          "label": "Lisää matkatoimiston tiedot"
        }
      }
    }
  }
}
